module.exports = __webpack_public_path__ + "img/globus.4b2acd71.png";